import LocationSetup from "./LocationSetup";

export { LocationSetup };
